import Const from 'constants';

let Theme = {
    toggleTheme(data) {
        return {
            type: Const.TOGGLE_THEME,
            data,
        };
    },
};

export default Theme;
